import { render, staticRenderFns } from "./EventTaskContainer.vue?vue&type=template&id=5f43fed4&scoped=true"
import script from "./EventTaskContainer.vue?vue&type=script&lang=ts"
export * from "./EventTaskContainer.vue?vue&type=script&lang=ts"
import style0 from "./EventTaskContainer.vue?vue&type=style&index=0&id=5f43fed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f43fed4",
  null
  
)

export default component.exports